import { render, staticRenderFns } from "./144.vue?vue&type=template&id=2b9d9b6b&scoped=true&"
var script = {}
import style0 from "./144.vue?vue&type=style&index=0&id=2b9d9b6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9d9b6b",
  null
  
)

export default component.exports